'use client';

import { useSiteData } from "@/hooks/api/useSite";
import AppAuthenticated from "../AppAuthenticated";

const WithData = (props: any) => {
    const { isLoading } = useSiteData();

    if (isLoading) {
        return null;
    }

    return (
        <>
        <AppAuthenticated children={props.children}/>
        </>
    );
};

export default WithData;


